module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.f245f4a.ttf";